export default "__VITE_PUBLIC_ASSET__102acbfa__"